module.exports = __webpack_public_path__ + "static/media/nav-prep-form-active.737263d0.svg";